class Block {
  static TYPE_IMAGE = "image";
  static TYPE_TEXT = "text";
  static TYPE_YOUTUBE = "youtube";
  static TYPE_VIDEO = "video";
  static TYPE_PDF = 'pdf';

  constructor(params) {
    this.type = params.type;
    this.name = params.name;

    if (params.backgroundColor) {
      this.backgroundColor = params.backgroundColor;
    }
    // default background color shall be 'none' (transparent) so that
    // content background color is visible.
    //
    //else {
    //	this.backgroundColor = 'white';
    //}

    if (params.scale) {
      this.scale = params.scale;
    } else {
      this.scale = 1;
    }

    if (params.translationX) {
      this.translationX = params.translationX;
    } else {
      this.translationX = 0;
    }

    this.data = params.data;
    this.resources = params.resources;
  }
}

export default Block;
